import React from 'react';
import ToggleOff from '@mui/icons-material/ToggleOff';
import ToggleOn from '@mui/icons-material/ToggleOn';

const toggleStyle = (color) => ({
    color,
    fontSize: 'calc(var(--icon-size) * var(--font-size-multiplier))',
    cursor: 'not-allowed',
    opacity: .5,
});

const TemplateBooleanToggleCell = ({ checked, inactiveColor }) => (
    checked ? (
        <ToggleOn style={toggleStyle('var(--accent)')} />
    ) : (
        <ToggleOff style={toggleStyle(inactiveColor)} />
    )
);

export default TemplateBooleanToggleCell;
